import ArrayWidget from './Array.component';

export default ArrayWidget;
